import Cancel from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';

function ACHType({
  fundingSource = {
    account_type: '',
    account_number: '',
    is_rtp_enabled: false,
  },
  ...rest
}) {
  return (
    <>
      <Typography sx={{ color: 'black' }} {...rest}>
        {`${
          fundingSource.account_type.charAt(0).toUpperCase() +
          fundingSource.account_type.slice(1)
        } ending in ${fundingSource.account_number}`}
      </Typography>

      <Typography sx={{ color: 'black', marginTop: '4px' }} {...rest}>
        <Grid container items alignItems='center' gap='4px'>
          {fundingSource.is_rtp_enabled ? (
            <>
              <CheckCircleIcon sx={{ color: '#008143' }} />
              {''}
              RTP compatible
            </>
          ) : (
            <>
              <Cancel sx={{ color: '#C21B44' }} />
              {''}
              RTP incompatible
            </>
          )}
        </Grid>
      </Typography>
    </>
  );
}

ACHType.propTypes = {
  fundingSource: PropTypes.shape({
    account_type: PropTypes.string,
    account_number: PropTypes.string,
    is_rtp_enabled: PropTypes.bool,
  }),
  // spread via rest
  variant: PropTypes.string,
};

export default ACHType;
